import React from "react";

const BluePrintIcon = () => {
  return (
    <svg data-testid="blueprint-icon" width={14} height={12} viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.125 10.875H12.625V1.125H1.375V8.625H7.375V10.875H8.875" stroke="#999999" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.625 4.875H1.375" stroke="#999999" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.625 3.375V6.375" stroke="#999999" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.625 7.125V4.875H12.625" stroke="#999999" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default BluePrintIcon;
